const SEEDANCE_20_INPUT_VIDEO_BILLING_MODEL_KEYS = new Set([
  'seedance-2.0-mini',
  'seedance-2.0-fast',
  'seedance-2.0',
  'seedance-2.5',
  'seedance-2.0-fast-vip',
  'seedance-2.0-vip',
  'seedance-2.0-mini-vip',
  'seedance-2.5-vip',
]);

const normalizePositiveDuration = (value) => {
  const duration = Number(value);
  return Number.isFinite(duration) && duration > 0 ? duration : 0;
};

const roundBillableDuration = (value) => Math.round(normalizePositiveDuration(value));

export const isSeedance20InputVideoBillingModel = (modelKey) => (
  SEEDANCE_20_INPUT_VIDEO_BILLING_MODEL_KEYS.has(
    String(modelKey || '').trim().toLowerCase()
  )
);

export const getInputVideoDurationSeconds = (inputAssets = []) => {
  if (!Array.isArray(inputAssets)) return 0;

  const totalDuration = inputAssets.reduce((sum, asset) => {
    if (String(asset?.type || '').trim().toLowerCase() !== 'video') return sum;
    return sum + roundBillableDuration(asset?.durationSeconds ?? asset?.duration);
  }, 0);

  return totalDuration;
};

export const getSeedance20BillableDuration = ({
  modelKey,
  outputDuration,
  inputVideoDuration,
  fallbackOutputDuration = 4,
} = {}) => {
  const normalizedOutputDuration = roundBillableDuration(
    normalizePositiveDuration(outputDuration) || fallbackOutputDuration
  );
  const normalizedInputVideoDuration = isSeedance20InputVideoBillingModel(modelKey)
    ? roundBillableDuration(inputVideoDuration)
    : 0;

  return normalizedOutputDuration + normalizedInputVideoDuration;
};

export const getSeedance20CreditCost = ({
  modelKey,
  outputDuration,
  inputVideoDuration,
  perSecondCost,
  fallbackOutputDuration = 4,
} = {}) => {
  const normalizedPerSecondCost = normalizePositiveDuration(perSecondCost);
  if (!normalizedPerSecondCost) return 0;

  const billableDuration = getSeedance20BillableDuration({
    modelKey,
    outputDuration,
    inputVideoDuration,
    fallbackOutputDuration,
  });

  // Round durations before applying the rate so the final charge always stays
  // an exact multiple of the model's per-second price.
  return billableDuration * normalizedPerSecondCost;
};
